<template>
  <div>
     <!-- 导入组件 -->
    <ImportPopup
      ref="importPopup"
      title="批量导入保单附件"
      :upload="upload"
      @validate="validate"
      @open="open"
      group="assert"
      code="assert_guarantee_slip"
    >
      <el-tabs v-model="activeTab"  @tab-click="clearForm">
        <el-tab-pane label="按保单号导入" name="1">
          <div class="container">
            <img :src="require('@/assets/img/policy.png')" />
          </div>
        </el-tab-pane>
        <el-tab-pane label="按车牌号导入" name="2">
          <div class="container">
            <img :src="require('@/assets/img/policyByPlatNo.png')" />
          </div>
          <div class="import_summary mt16">导入说明：按此方式导入，文件将默认导入车辆最新创建的保险数据中</div>
        </el-tab-pane>
      </el-tabs>
      <el-form class="mt16" :inline="true" ref="upload" :model="imageParams" :rules="rules">
        <el-form-item label="选择导入类型" prop="imgType">
          <el-select
            v-model="imageParams.imgType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in imgTypeList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </ImportPopup>
  </div>
</template>
<script>
import ImportPopup from '@/components/ImportPopup'
import { uploadTaskCreate } from '@/api/currencyApi.js'

export default {
  components: {
    ImportPopup,
  },
  data() {
    return {
      activeTab: '1',
      imageParams: {
        imgType: '',
      }, // 图片上传
      imgTypeList: [
        {
          label: '交强险',
          value: 53,
        },
        {
          label: '商业险',
          value: 54,
        },
        {
          label: '承运人责任险',
          value: 55,
        },
        {
          label: '客伤险',
          value: 56,
        },
        {
          label: '车船税',
          value: 57,
        },
        {
          label: '盗抢险',
          value: 58,
        },
      ], // 图片上传列表
      rules: {
        imgType: [
          { required: true, message: '导入类型不能为空', trigger: 'change' },
        ],
      },
    }
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    upAppendix() {
      this.$refs.importPopup.showDialog()
    },
    // 导入返回值
    upload(url, file) {
      return new Promise((resolve, reject) => {
        if (this.imageParams.imgType === '' || url === '') return
        this.$refs.importPopup.closeDialog()
        const params = {
          uploadType: this.imageParams.imgType,
          fileAddress: url,
          fileName: file.name,
          extInfo: this.activeTab, // 按保单号导入：1，按车牌号导入：2
        }
        uploadTaskCreate(params).then((res) => {
          const { code } = res
          if (code === 1) {
            this.$confirm('上传成功', '提示', {
              confirmButtonText: '查看导入历史',
              cancelButtonText: '取消',
              showConfirmButton: this.judgePermission('policyImportHistory'),
            }).then(() => {
              this.$router.push({
                name: 'policyFileImportHistory',
              })
            }).catch(() => null)
            this.$emit('upSuccess')
          }
          resolve()
        }).catch(() => {
          this.$refs.importPopup.closeDialog()
          reject()
        })
      })
    },
    // 上传成功emit成功事件
    // eslint-disable-next-line vue/no-unused-properties, @typescript-eslint/no-empty-function
    selectBtn() {},
    // 批量导入校验
    validate(callback) {
      this.$refs.upload.validate((valid) => {
        if (valid) {
          callback()
        }
      })
    },
    open() {
      this.activeTab = '1'
      this.clearForm()
    },
    clearForm() {
      this.$nextTick(() => {
        this.$refs.upload.resetFields()
        this.imageParams.imgType = ''
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .importPopup{
  margin-top: -16px;
}
.import_summary{
  color: red;
}
</style>
